import { Box, BoxProps } from '@cdl/heartbeat-react';
import { PropsWithChildren } from 'react';

export const TaskMetricSection: React.FC<PropsWithChildren<BoxProps>> = ({
  children,
  ...boxProps
}) => {
  return (
    <Box
      borderRadius='4px'
      bgColor='neutral.0'
      py='m'
      px='xl'
      {...boxProps}
      shadow={400}
      w='100%'
      h='100%'
    >
      {children}
    </Box>
  );
};
